// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"53229533","365":"6ce973f1"}[chunkId] + ".chunk.css";
};